(function () {
  'use strict';

  // Cache: 'handle:sectionId' -> section HTML string
  var cache = {};

  function init() {
    document.querySelectorAll('[data-siblings-picker]').forEach(bindPicker);

    // Ensure the active main-slider slide's images are visible on page load.
    // image-element's IntersectionObserver fires async and can miss the slide
    // after Flickity repositions it, leaving the image-wrap in shimmer state.
    document.querySelectorAll('[data-product-photos] .starting-slide .image-wrap, [data-product-photos] .is-selected .image-wrap').forEach(function (wrap) {
      wrap.classList.add('loaded');
    });

    prefetchSiblings();
  }

  // Kick off background fetches for every sibling so the first click is instant.
  function prefetchSiblings() {
    var seen = {};
    document.querySelectorAll('[data-sibling-swatch]').forEach(function (input) {
      if (input.dataset.isCurrentProduct === 'true') return;

      var handle    = input.dataset.siblingHandle;
      var wrapper   = input.closest('[data-siblings-picker]');
      if (!wrapper) return;
      var sectionId = wrapper.dataset.siblingsSectionId;
      var key       = handle + ':' + sectionId;

      if (seen[key] || cache[key]) return;
      seen[key] = true;

      fetch('/products/' + handle + '?sections=' + encodeURIComponent(sectionId), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data[sectionId]) cache[key] = data[sectionId];
      })
      .catch(function () {});
    });
  }

  function bindPicker(wrapper) {
    wrapper.querySelectorAll('[data-sibling-swatch]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;

        var isCurrentProduct = input.dataset.isCurrentProduct === 'true';
        var variantId        = input.dataset.variantId;
        var shadeName        = input.dataset.shadeName;
        var handle           = input.dataset.siblingHandle;
        var url              = input.dataset.siblingUrl;
        var sectionId        = wrapper.dataset.siblingsSectionId;

        if (isCurrentProduct) {
          selectVariant(wrapper, sectionId, variantId, shadeName);
        } else {
          switchToSibling(handle, url + '?variant=' + variantId, sectionId, wrapper, shadeName, variantId);
        }
      });
    });
  }

  // ── Same-product variant selection ──────────────────────────────────────
  function selectVariant(wrapper, sectionId, variantId, shadeName) {
    var sectionEl = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!sectionEl) return;

    // Parse the variant object from the page's embedded JSON
    var jsonEl = sectionEl.querySelector('[data-variant-json]');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) { variant = variants[i]; break; }
    }
    if (!variant) return;

    // Update the hidden master select so the cart form has the right id
    var masterSelect = sectionEl.querySelector('[data-product-select]');
    if (masterSelect) {
      masterSelect.value = variantId;
      masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update URL without reloading
    history.replaceState({}, '', window.location.pathname + '?variant=' + variantId);

    // Update shade label
    updateShadeLabel(wrapper, shadeName);

    // Dispatch the events that theme.Product listens to for price/cart/image updates.
    // theme.delegate.on strips the namespace suffix when matching, so dispatching
    // 'variantChange' triggers listeners registered as 'variantChange.product-xyz'.
    var detail = { variant: variant };
    sectionEl.dispatchEvent(new CustomEvent('variantChange',          { detail: detail }));
    sectionEl.dispatchEvent(new CustomEvent('variantPriceChange',     { detail: detail }));
    sectionEl.dispatchEvent(new CustomEvent('variantUnitPriceChange', { detail: detail }));
    if (variant.featured_image) {
      sectionEl.dispatchEvent(new CustomEvent('variantImageChange', { detail: detail }));
    }
  }

  // ── Cross-product AJAX switch ────────────────────────────────────────────
  function switchToSibling(handle, url, sectionId, pickerWrapper, shadeName, variantId) {
    var sectionEl = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!sectionEl) { window.location.href = url; return; }

    pickerWrapper.style.opacity       = '0.6';
    pickerWrapper.style.pointerEvents = 'none';

    var key = handle + ':' + sectionId + ':' + variantId;

    (cache[key]
      ? Promise.resolve(cache[key])
      : fetch('/products/' + handle + '?variant=' + variantId + '&sections=' + encodeURIComponent(sectionId), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function (r) {
          if (!r.ok) throw new Error('network');
          return r.json();
        })
        .then(function (data) {
          var html = data[sectionId];
          if (!html) throw new Error('section missing');
          cache[key] = html;
          return html;
        })
    )
    .then(function (html) {
      var doc   = new DOMParser().parseFromString(html, 'text/html');
      var newEl = doc.querySelector('[data-section-type="product"]');
      if (!newEl) throw new Error('no product section');

      // Clean up old theme.Product instance
      var old = theme.sections._findInstance(sectionId);
      if (old) {
        if (typeof old.onUnload === 'function') old.onUnload();
        if (old.settings && old.settings.namespace) sectionEl.off(old.settings.namespace);
        window.off('quickadd:loaded:' + sectionId);
        theme.sections._removeInstance(sectionId);
      }

      // Update section container attributes
      ['productId', 'productHandle', 'productTitle'].forEach(function (k) {
        if (newEl.dataset[k]) sectionEl.dataset[k] = newEl.dataset[k];
      });

      // Swap inner content
      sectionEl.innerHTML = newEl.innerHTML;

      // Update browser URL to include the variant
      history.pushState({ siblingSwap: true }, '', url);

      // Re-initialise theme.Product on the same container node
      theme.sections._createInstance(sectionEl);

      // Mirror what _onSectionLoad does (AOS + collapsibles etc.)
      if (window.AOS) AOS.refreshHard();
      if (theme.initGlobals) theme.initGlobals();

      // Force-show the active slide's images immediately
      sectionEl.querySelectorAll('[data-product-photos] .starting-slide .image-wrap, [data-product-photos] .is-selected .image-wrap').forEach(function (wrap) {
        wrap.classList.add('loaded');
      });

      // Re-bind picker in the freshly rendered content
      var newPicker = sectionEl.querySelector('[data-siblings-picker]');
      if (newPicker) bindPicker(newPicker);
    })
    .catch(function () {
      window.location.href = url;
    })
    .finally(function () {
      pickerWrapper.style.opacity       = '';
      pickerWrapper.style.pointerEvents = '';
    });
  }

  function updateShadeLabel(wrapper, shadeName) {
    var el = wrapper.querySelector('[data-siblings-current-shade]');
    if (el) el.textContent = shadeName;
  }

  // Handle browser back/forward after a sibling swap
  window.addEventListener('popstate', function (evt) {
    if (evt.state && evt.state.siblingSwap) window.location.reload();
  });

  document.addEventListener('page:loaded', init);
  if (document.readyState !== 'loading') init();
})();
